var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"main-header__list"},[_c('li',{staticClass:"main-header__item"},[_c('a',{staticClass:"main-header__link",attrs:{"title":"Search","href":"javascript:;"},on:{"click":function($event){return _vm.$store.Search.ACTIONS.toggle()}}},[_c('fa-icon',{attrs:{"icon":['fas', 'search']}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }